import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { useEffect, useState } from 'react';

import { conciliationChannels } from '@constants/channel';
import { conciliationStatus } from '@constants/conciliationStatus';
import { getLabel, getValidDate } from '@shared/utils';

interface ConcilationData {
  id_bank: string;
  channel: string;
  state: string;
  dateTran: string;
  amount: string;
  factcodi: string;
  idconciliation: string;
  dateConciliation: string;
}

interface Summary {
  name: string;
  count: number;
  amount: string;
}

const useStyles = makeStyles({
  row: {
    fontSize: '19px',
    textAlign: 'left',
    letterSpacing: '0px',
    opacity: '1',
    paddingLeft: '5px',
    paddingRight: '5px',
  },
});

interface SummaryConcilationCardProps {
  data: ConcilationData[];
}

const SummaryConcilationCard: React.FC<SummaryConcilationCardProps> = ({ data }) => {
  const classes: any = useStyles();
  const [summary, setSummary] = useState<Summary[]>([
    {
      name: conciliationChannels.WALLET,
      count: 0,
      amount: '0.00',
    },
    {
      name: conciliationChannels.GANA_MOVIL,
      count: 0,
      amount: '0.00',
    },
    {
      name: conciliationChannels.GANANET,
      count: 0,
      amount: '0.00',
    },
  ]);
  const [totalAmount, setTotalAmount] = useState<number>(0);

  const syncAmount = (rows: ConcilationData[]) => {
    let total = 0;
    const wallet = rows.filter(
      (correspondent) =>
        correspondent.channel === conciliationChannels.WALLET &&
        correspondent.state === conciliationStatus.ACCEPTEDSETTLEMENTCOMPLETED
    );
    const ganaMovil = rows.filter(
      (correspondent) =>
        correspondent.channel === conciliationChannels.GANA_MOVIL && correspondent.state === conciliationStatus.PAGADO
    );
    const gananet = rows.filter(
      (correspondent) =>
        correspondent.channel === conciliationChannels.GANANET && correspondent.state === conciliationStatus.PAGADO
    );
    setSummary([
      {
        name: conciliationChannels.WALLET,
        count: wallet.length,
        amount: wallet.reduce((a: any, b) => parseFloat(a) + parseFloat(b.amount), 0).toFixed(2),
      },
      {
        name: conciliationChannels.GANA_MOVIL,
        count: ganaMovil.length,
        amount: ganaMovil.reduce((a: any, b) => parseFloat(a) + parseFloat(b.amount), 0).toFixed(2),
      },
      {
        name: conciliationChannels.GANANET,
        count: gananet.length,
        amount: gananet.reduce((a: any, b) => parseFloat(a) + parseFloat(b.amount), 0).toFixed(2),
      },
    ]);
    total =
      wallet.reduce((a: any, b) => parseFloat(a) + parseFloat(b.amount), 0) +
      ganaMovil.reduce((a: any, b) => parseFloat(a) + parseFloat(b.amount), 0) +
      gananet.reduce((a: any, b) => parseFloat(a) + parseFloat(b.amount), 0);
    setTotalAmount(total);
  };

  const formatData = (data: ConcilationData[]): ConcilationData[] => {
    return data.map((concilation: any) => ({
      id_bank: concilation.id_bank,
      channel: concilation.channel,
      state: concilation.state,
      dateTran: getValidDate(concilation.dateTran),
      amount: parseFloat(concilation.amount).toFixed(2),
      factcodi: concilation.factcodi,
      idconciliation: concilation.conciliationNumber,
      dateConciliation: getValidDate(concilation.dateConcilation),
    }));
  };

  useEffect(() => {
    syncAmount(formatData(data));
  }, [data]);

  return (
    <TableContainer component={Paper}>
      <Table className={classes.table} size="small" aria-label="a dense table">
        <TableHead>
          <TableRow>
            <TableCell>{getLabel('channel')}</TableCell>
            <TableCell align="right">{getLabel('count')}</TableCell>
            <TableCell align="right">{getLabel('amount')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {summary.map((row) => (
            <TableRow key={row.name} style={{ height: 10 }}>
              <TableCell size="small" component="th" scope="row">
                {row.name}
              </TableCell>
              <TableCell align="right">{row.count}</TableCell>
              <TableCell align="right">{row.amount}</TableCell>
            </TableRow>
          ))}
          <TableRow>
            <TableCell colSpan={2} align="right">
              {getLabel('total')}
            </TableCell>
            <TableCell align="right">{parseFloat(totalAmount.toFixed(2)).toFixed(2)}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default SummaryConcilationCard;
